import React from 'react';
import { FiTrash2 } from 'react-icons/fi';
import { useSession } from 'src/app/hooks/useSession';
import Swal from 'sweetalert2';
import { t } from 'i18next';
import { useCheckIncludeProfiles } from '@/app/hooks/useAuthorityLevel';
import { ChatMessage, ChatMessageActions, ChatMessageBody, ChatMessageHeader, ChatMessageInside, ChatMessageText, ChatMessageTitle, ChatMessageWrapper } from '@/components/custom/chat';
import { Badge } from '@/components/ui/badge';
import { AvatarWrapper } from '@/components/ui/avatar';

export default function CommentCard({ comment, onDelete }) {
  const { session } = useSession();

  const userId = session?.user?.id;
  const isAdmin = !useCheckIncludeProfiles({ only: ['student'] });

  const handleDelete = () => {
    Swal.fire({
      title: t('projects.warningDeleteCommentTitle'),
      confirmButtonText: t('button.yes'),
      showDenyButton: true,
      denyButtonText: t('button.no'),
      showCloseButton: true
    }).then(res => {
      if (res.isConfirmed) {
        onDelete(comment.id);
      }
    });
  };

  return (
    comment?.user && (
      <ChatMessageWrapper>
        <ChatMessage>
          <AvatarWrapper
            src={comment?.user?.image?.url}
            text={comment?.user?.name}
          />

          <ChatMessageInside>
            <ChatMessageHeader>
              <ChatMessageTitle>{comment?.user?.name}</ChatMessageTitle>
              <Badge
                variant="bright"
                size="xs"
              >
                {comment?.user?.['profile-names'][0]}
              </Badge>
            </ChatMessageHeader>
            <ChatMessageBody>
              <ChatMessageText>{comment?.body}</ChatMessageText>
            </ChatMessageBody>
          </ChatMessageInside>

          {(isAdmin || comment?.user?.id === userId) && (
            <ChatMessageActions>
              <FiTrash2
                className="w-4 cursor-pointer text-danger"
                onClick={() => handleDelete()}
              />
            </ChatMessageActions>
          )}
        </ChatMessage>
      </ChatMessageWrapper>
    )
  );
}
